import { ManageRolesTablePropertiesSidePanelContent } from "PFApp/activities/manage_roles/parts/table_properties/manage_roles_table_properties_side_panel_content";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useTranslation } from "react-i18next";

type ManageRolesTablePropertiesSidePanelProps = {
  isVisible: boolean;
  onCloseClick: () => void;
};

export const ManageRolesTablePropertiesSidePanel = ({
  isVisible,
  onCloseClick
}: ManageRolesTablePropertiesSidePanelProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });

  return (
    <SidePanel
      show={isVisible}
      fullHeight
      onClose={onCloseClick}
      title={t("tableProperties.title")}
      subTitle={t("tableProperties.subTitle")}
      qaId="ManageRolesTablePropertiesSidePanel"
    >
      <ManageRolesTablePropertiesSidePanelContent />
    </SidePanel>
  );
};
